/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const SignOutStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.8999 12H20.4999M16.0606 16.5L20.1769 12.5437C20.3749 12.3534 20.4739 12.2582 20.511 12.1485C20.5436 12.052 20.5436 11.948 20.511 11.8515C20.4739 11.7418 20.3749 11.6466 20.1769 11.4563L16.0606 7.5M11 3H8.3C6.61984 3 5.77976 3 5.13803 3.32698C4.57354 3.6146 4.1146 4.07354 3.82698 4.63803C3.5 5.27976 3.5 6.11984 3.5 7.8V16.2C3.5 17.8802 3.5 18.7202 3.82698 19.362C4.1146 19.9265 4.57354 20.3854 5.13803 20.673C5.77976 21 6.61984 21 8.3 21H11"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { SignOutStrokeIcon };
